/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getOrgAuthProviderHistory } from '../../../../../../../store/reducers/organization/orgAuthProvider/orgAuthProviderAction';

const OrgAuthProviderHistory = ({ selectedOrgAuthProvider }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const orgAuthProviderHistory = useSelector(state => state.orgAuthProvider.orgAuthProviderHistory)
    useEffect(() => {
        dispatch(getOrgAuthProviderHistory({ "organizationAuthProviderID": selectedOrgAuthProvider.organizationAuthProviderID }))

    }, [dispatch, selectedOrgAuthProvider]);
    useEffect(() => {
        setHistoryList([]);
        if (orgAuthProviderHistory?.length > 0) {
            orgAuthProviderHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.authProviderName,
                        details: element.Record.organizationAuthProviderDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgAuthProviderHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Organization Identity Provider History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default OrgAuthProviderHistory;